module.exports = __webpack_public_path__ + "static/media/stop-finish.b90e78c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/stop-finish.svg
// module id = 770
// module chunks = 0